<template>
  <div style="width:100%">  
      <div  :class="{'opacity-table': tableTable>=0 && typeof tableTable === 'number'}">
        <b-input-group
          size="sm"
          class="mb-3 sw-search"
          prepend="Buscar"
        >        
          <template v-slot:prepend> 
              <div style="border:1px solid #ced4da;border-bottom:none;border-top-left-radius:0.25rem" v-if="awaitDataGet">             
                <sw-loading></sw-loading>
              </div>  
              <div v-else>
                <b-button id="updateBtn" size="sm" @click="emitFiltrar" text="Button" variant="outline-primary">
                  <b-icon icon="arrow-repeat" scale="1.2" ></b-icon>
                  <b-tooltip triggers="hover" noninteractive target="updateBtn" >Refrescar</b-tooltip>
                </b-button> 
              </div> 
          </template>
            <b-form-input :autofocus="saveConfig.autofocus" @input="inputSearchs" v-model="currentSearch" placeholder="Escribe aquí para filtrar los resultados"></b-form-input>
          <b-input-group-append>
            <b-button size="sm" text="Button" variant="info">txt</b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button size="sm" text="Button" variant="secondary">Pdf</b-button>
          </b-input-group-append>
          <b-input-group-append>
            <b-button size="sm" text="Button" variant="success" class="search-radius">Excell</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
      <table  style="margin-bottom:0" class="table table--get table-hover border box-effect linear">
        <thead  :class="{'opacity-table': tableTable>=0  && typeof tableTable === 'number'}">
          <tr v-if="showBtns()">
            <th  v-for="(items,index) in tableItems" :key="'thGet'+index" style="padding: 5px">
              <div v-if="items.thead.btn">
                 <div  :id="'Btn'+index" style="display:inline">
                  ({{selectBtn(index)}}) <b-icon  :id="'optionsTableanular'+index" class="option-btn text-primary" icon="check-box" scale="1.6" ></b-icon> 
                </div> 
                <b-popover
                    :target="'Btn'+index"
                    placement="bottom"
                    triggers="hover"
                  ><template v-slot:default>
                      {{items.thead.msjBtn}}
                      <div class="text-center mt-3">
                        <b-button :disabled="selectBtn(index)<1 || tableTable>=0  && typeof tableTable === 'number'"  size="sm" @click="save('btn'+index,true)">  
                          {{items.thead.btn}} 
                        </b-button>
                      </div>
                    </template>  
                  </b-popover>             
              </div>
            </th>
            <th></th>
          </tr>
          <tr>
            <th v-for="(items,index) in tableItems" :key="'thGet'+index">  
              <b-row>
                <b-col md="2" lg="2" v-if="items.thead.btn" style="margin-right:0.5rem">
                  <b-form-checkbox
                        size="lg"
                        @change="checkAll($event,'btn'+index)"
                      >
                  </b-form-checkbox> 
                </b-col>
                <b-col style="padding:0;height: 30px;">
                  {{items.thead.th}}         
                  <span @click="items.thead.sort=sort(items.thead.sort,items.thead.sortTable,index)" class="sw-sort" v-if="items.thead.sort!==undefined" :class="{'sw-sortdown': items.thead.sort===false, 'sw-sortup': items.thead.sort===true}">
                  </span>  
                </b-col>
              </b-row> 
            </th>
            <th class="text-right"  v-if="tableOptions.modals!==undefined || tableOptions.options!==undefined">
              <b-row>               
                <b-col style="padding:0;height: 30px;">
                  Opciones 
                </b-col>
              </b-row>   
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(items,index) in sortedTable()" :key="'dataGetTable'+index" style="position:relative">
            <td v-if="items.tableTable!==undefined" :colspan="colspan()" class="bg-light box-effect linear">                
                  <sw-tabletable
                      :tableItems="table.items"
                      :tableSearch="table.search"
                      :tableOptions="table.options"
                      :tableIndex="table.index"
                      :tabla="table.tabla"
                      :name="table.tabla"
                      @save="save"
                      >
                  </sw-tabletable>                  
            </td>
            <td :class="{'opacity-table': tableTable>=0 && tableTable!==items.index && opentabletable!==items2  && typeof tableTable === 'number'}" v-for="(items2,index2) in tableItems" :key="'tdGet'+index2" v-if="items.tableTable===undefined" >
                <div v-if="items2.tbody.td">
                  <div v-if="!items2.thead.btn">
                    <div v-if="!items2.tbody.link">
                      <span   v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4">
                        <span v-if="items2.tbody.checks">
                          <span v-if="items[items4]===true">
                            {{items2.tbody.checks[index4]}}  
                          </span>                  
                        </span>
                        <span v-else>
                          <span v-if="items4.includes('text/')">
                              {{items4.replace('text/','')}}
                          </span>
                          <span v-else>
                            {{items[items4]}} 
                          </span>                                       
                        </span>
                      </span>
                    </div>
                    <div v-else>
                      <b-button variant="white" size="sm" @click="openLinks(items2.tbody.link,items[items2.tbody.td[0]])" class="btn-link">Pdf</b-button>
                    </div>                                    
                  </div>
                  <div v-if="items2.thead.btn">
                    <b-row>
                      <b-col md="2">
                        <b-form-checkbox
                              size="lg"
                              v-model="tableSave[name]['btn'+index2][items.index].check"
                            >
                        </b-form-checkbox>
                      </b-col>                
                      <sw-inputstable
                        v-for="(items4,index4) in items2.tbody.td" :key="'inputstable'+index4"
                        :tablaCampo="items4"
                        :index="items.index"
                        :name="name"
                        :btn="'btn'+index2"
                        >
                      </sw-inputstable>
                    </b-row>
                  </div>
                </div>
                <div v-if="items2.tbody.table && items[items2.tbody.table.tabla].length>0" style="position:relative">  
                    <b-icon :id="items.index+'popover'+index2"  @click="openTable(index,items2.tbody.table,items.index,index2);items.tableTable!=items.tableTable"  class="option-btn" icon="table" scale="1.3" variant="secondary"></b-icon>
                    <b-icon icon="shift-fill" scale="1.7" class="tableIcon" v-if="tableTable===items.index && opentabletable===index2 && !items2.thead.btn" rotate="180" variant="secondary"></b-icon>
                </div>
            </td> 
            <td :class="{'opacity-table': tableTable>=0  && typeof tableTable === 'number' &&  tableTable!==items.index && tableTable!==items.index}" class="text-right" v-if="(tableOptions.options!==undefined || tableOptions.modals!==undefined) && items.tableTable===undefined">     
                <div v-if="tableOptions.modals!==undefined"  style="display:inline-block;padding-left:5px;padding-right:5px">
                  <div v-for="(items3,index3) in tableOptions.modals" :key="'tableOptions'+index3"   style="display:inline-block;padding-left:5px;padding-right:5px">
                      <b-icon @click="selectModal(items.index,items3);updateGlobal({state:'openModal/modal/variant', data: 'secondary'})" :id="items3.modal+index3+'Modal'+index" class="option-btn" :icon="items3.icon" scale="1.7" variant="secondary"></b-icon>
                      <b-tooltip triggers="hover" noninteractive :target="items3.modal+index3+'Modal'+index">{{items3.modal}}</b-tooltip>
                  </div>
                </div>   
                <div style="display:inline-block;padding-left:5px;padding-right:5px" v-if="tableOptions.options!==undefined">
                  <div style="display:inline-block;padding-left:5px;padding-right:5px" v-if="tableOptions.options.editar!==undefined">
                    <b-icon  @click="selectModal(items.index,{modal: 'Editar', title: tableOptions.options.editar});updateGlobal({state:'openModal/modal/variant', data: 'primary'})" :id="'editarModal'+index" class="option-btn" icon="pencil" scale="1.7" variant="primary"></b-icon>
                    <b-tooltip triggers="hover" noninteractive :target="'editarModal'+index">Editar</b-tooltip>
                  </div> 
                  <div style="display:inline-block;padding-left:5px;padding-right:5px"  v-if="tableOptions.options.inactivar!==undefined">
                    <b-icon  @click="selectModal(items.index,{modal: 'Inactivar', title: tableOptions.options.inactivar});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})"  :id="'inactivarModal'+index" class="option-btn" variant="dark" icon="toggle-on" scale="1.8" ></b-icon>
                    <b-tooltip triggers="hover" noninteractive :target="'inactivarModal'+index">Inactivar</b-tooltip>
                  </div>  
                  <div style="display:inline-block;padding-left:5px;padding-right:5px"  v-if="tableOptions.options.anular!==undefined">
                    <b-icon  @click="selectModal(items.index,{modal: 'Anular', title: tableOptions.options.anular});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})"  :id="'anularModal'+index" class="option-btn text-inactive" icon="circle-slash" scale="1.6" ></b-icon>
                    <b-tooltip triggers="hover" noninteractive :target="'anularModal'+index">Anular</b-tooltip>
                  </div>      
                  <div style="display:inline-block;padding-left:5px;padding-right:5px" v-if="tableOptions.options.eliminar!==undefined">
                    <b-icon  @click="selectModal(items.index,{modal: 'Eliminar', title: tableOptions.options.eliminar});updateGlobal({state:'openModal/modal/variant', data: 'secondary'})" :id="'eliminarModal'+index" class="option-btn" icon="trash" scale="1.7" variant="danger"></b-icon>
                    <b-tooltip triggers="hover" noninteractive :target="'eliminarModal'+index">Eliminar</b-tooltip>
                  </div>
                </div>                
            </td>
          </tr>
        </tbody>
      </table>
      <b-row :class="{'opacity-table': tableTable>=0  && typeof tableTable === 'number' }" >    
        <b-col md="3" class="p-0">
          <b-pagination style="margin-bottom:0" class="paginatableget" v-model="pagination" :total-rows="rows" size="sm" first-number  align="fill"></b-pagination>
        </b-col> 
        <b-col  class="p-0">
        </b-col>
      </b-row>  
      <b-modal 
          v-model="openModal.modal.value"
          :title="openModal.modal.title" 
          :header-bg-variant="openModal.modal.variant"
          header-text-variant="light"
          :hide-footer="true"  
          :no-close-on-backdrop="true" 
          size="xl"  
          >           
            <slot name="modal">
            </slot>       
        </b-modal>      
  </div>
</template>
<script>
import SwTabletable from '@/components/dataTable/tableTable.vue'
import SwInputstable from '@/components/forms/inputsTable.vue'
import SwLoading from '@/components/notification/loading.vue'
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import debounce from 'debounce'
function cleanParameter(value)
  {
    if(value==null)
    {
      return '';
    }
    return value.toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
  }
export default 
{
  name: 'swTableget',
  components: { SwInputstable, SwTabletable, SwLoading  },
  props: {
    tableSearch: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableItems: {
      type: Array,
      default: function()
      {
        return []
      }
    },
    tableOptions: {
      type: Object,
      default: function()
      {
        return {}
      }
    },
    name: {
      type: String,
      default: ''
    },
    route: {
      type: String,
      default: ''
    },
    dataRoute: {
      type: String,
      default: ''
    },
    dataBackend: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      awaitDataGet: false,
      currentSearch:'',
      currentSort:'id',
      currentSortDir: '', 
      tableTable: false, 
      opentabletable: false,
      table: {  
        items: [],
        search: [],
        options: {},
        name: '',
        index: 0,
      },
      pagination: 1,
      rows: 20      
    }
  },
  created: async function() { 
    this.awaitDataGet=true
      await this.getDataGet({route: this.route, data: this.dataRoute})
      let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
      await this.updateCrud({state: 'tableSave', data: checks}) 
    this.awaitDataGet=false
  },
  computed: {    
  },
  methods: { 
    async emitFiltrar()
    {
      this.awaitDataGet=true
        await this.getDataGet({route: this.route, data: this.dataRoute})
        let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
        await this.updateCrud({state: 'tableSave', data: checks}) 
      this.awaitDataGet=false
    },
    inputSearchs: debounce(async function ()
    {
      if(this.tableTable>=0 && typeof this.tableTable === 'number')
      {
          await this.spliceDataGet(this.tableTable+1)
          this.tableTable=true
      }  
      if(this.dataBackend)
      {
        await this.getDataGet({route: this.route, data: this.currentSearch})
        let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
        await this.updateCrud({state: 'tableSave', data: checks}) 
      } 
            
    },500),
    openLinks(link,id)
    {
      window.open( this.url+link+'?id='+id+'&token='+this.token,'_blank')
    },
    async asignTableSave(data)
    {      
      let checks = {} 
      checks[this.name]= {}      
      for (let m = 0; m < data.length; m++) 
      {
        for(let i=0; i<this.tableItems.length;i++)
        {
          if(this.tableItems[i].thead.btn!==undefined)
          {
            if(checks[this.name]['btn'+i]===undefined)  
            {
                checks[this.name]['btn'+i]=[]
            }
            checks[this.name]['btn'+i][m]={}
            checks[this.name]['btn'+i][m].id=m
            checks[this.name]['btn'+i][m].check=false

            if(this.tableItems[i].tbody.td && data[m].tableTable===undefined) 
            {
              for (let j = 0; j < this.tableItems[i].tbody.td.length; j++) {
                let tablaCampo= this.tableItems[i].tbody.td[j].split('/')
                if(checks[this.name]['btn'+i][m][tablaCampo[0]]===undefined)  
                {
                  checks[this.name]['btn'+i][m][tablaCampo[0]]={}
                }
                checks[this.name]['btn'+i][m][tablaCampo[0]].id=data[m][tablaCampo[0]].id
                checks[this.name]['btn'+i][m][tablaCampo[0]][tablaCampo[1]]=data[m][tablaCampo[0]][tablaCampo[1]]
              }              
            }      
          }
          else{          
            if(this.tableItems[i].tbody.table!==undefined)
            {           
              if(this.tableTable===false)
              {
                this.tableTable=true
              }
            } 
          }
        } 
      } 
      return checks
    }, 
    async save(data,btn=false)
    {         
      if(btn===true)
      {  
          let valuesForm= {}      
					for (let i = 0; i < this.tableSave[this.name][data].length; i++) {
            if(this.tableSave[this.name][data][i].check===true)
            {
              let objectKeys= Object.keys(this.tableSave[this.name][data][i]) 
              for (let j = 0; j < objectKeys.length; j++) {
                if(objectKeys[j]!=='id' && objectKeys[j]!=='check') { 
                    if(valuesForm[objectKeys[j]]===undefined)
                    {
                    valuesForm[objectKeys[j]]=[]
                    }
                    valuesForm[objectKeys[j]].push(this.tableSave[this.name][data][i][objectKeys[j]])
                    this.pushDataPost({ state: 'tablaPost',data: objectKeys[j]})
                }              
              }
            }             
          }	
          await this.updateDataForm({data: valuesForm})				
      }
      this.$emit('save',{save:false,ftn:data})
    },
    showBtns()
    {
     return this.tableItems.find(list => list.thead.btn!==undefined)       
    },
    selectBtn(btn)
    {   
       let selectBtnLength = this.tableSave[this.name]['btn'+btn].filter( list => list.check)
       return selectBtnLength.length  
    },
    nameSaveBtn(btn){
      let nameBtn
      btn= btn.split('_')
      for (let i = 0; i < btn.length; i++) {
        btn[i]=btn[i].charAt(0).toUpperCase()+btn[i].substring(1).toLowerCase()        
      }
      return btn.toString().replace(',',' ')
    
    },
    checkAll(event,btn)
    {
      for (let i = 0; i < this.tableSave[this.name][btn].length; i++) {
        this.changeCrud({state: 'tableSave/'+this.name+'/'+btn+'/'+i+'/check', boolean: event})        
      }
    },
    selectModal(index,modal)
    {
      this.updateGlobal({state: 'openModal/modal/value',    data: true });
      this.updateGlobal({state: 'openModal/modal/title',    data: modal.title});
      this.updateGlobal({state: 'openModal/modal/modal',    data: modal.modal});
      this.resetDataForm();
      this.updateGlobal({state: 'indexData', data: index});
    },
    sort(sort,td,index){   
      for(var i=0;i<this.tableItems.length;i++)
      {
        if(index!==i)
        {
          if(this.tableItems[i].thead.sort!==undefined)
          {
            this.tableItems[i].thead.sort=null
          }          
        }        
      }
      this.currentSort=td  
      this.currentSortDir = 'desc'
      if(sort===null || sort===false)
      {
        this.currentSortDir = 'asc'
        return true
      }
      return !sort
    },
    sortedTable()
    {
      let vm = this;
      let popoverMap = []

      let dataFilter = this.deepCopyTable(this.dataGet[this.namePath].data) 
      if(!this.dataBackend)
      {        
        dataFilter = dataFilter.filter(list => {
          return this.tableSearch.find( items => {
              return cleanParameter(list[items]).indexOf(cleanParameter(this.currentSearch)) > -1
            })         
        })    
      }     
      return dataFilter.sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if(a[this.currentSort] > b[this.currentSort]) return  1 * modifier
        return 0
      }); 
    },  
    colspan()
    {
       let colspan=0
       if(this.tableOptions.options || this.tableOptions.modals)
       {
         colspan=1
       }
       return colspan + this.tableItems.length
    },
    async openTable(index,table,itemIndex,indexopen)
    {
      let searchTableTable={}
      searchTableTable.tableTable=false
      let campoytabla
      for (let i = 0; i < this.tableSearch.length; i++) {
        searchTableTable[this.tableSearch[i]] = this.sortedTable()[index][this.tableSearch[i]]       
      }
      if(this.tableTable!==false) //si existe una table en el td
      {    
        if(this.tableTable!==true) // si esta abierta alguna table
        {
          await this.spliceDataGet(this.tableTable+1)
          let keysTableSave= Object.keys(this.tableSave[this.name])
          for (let i = 0; i < keysTableSave.length; i++) {
              this.tableSave[this.name][keysTableSave[i]].splice(itemIndex+1,1)            
          }
        }
        if(itemIndex!==this.tableTable) // si la posicion del tr es diferente a la del tr con el table abierto
        {
          this.opentabletable=indexopen

          if(index>this.tableTable && this.tableTable!==true)
          {
            index=index-1
            itemIndex=itemIndex-1
          }
          this.dataGet[this.namePath].data.splice(itemIndex+1,0,searchTableTable)  
          this.tableTable = itemIndex
          this.table=table
          this.table.index=itemIndex   
          let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
          await this.updateCrud({state: 'tableSave', data: checks}) 
        }
        else{
          if(this.opentabletable===indexopen)
          {
            this.tableTable=true
          }
          else{
            this.opentabletable=indexopen
            if(index>this.tableTable && this.tableTable!==true)
            {
              index=index-1
              itemIndex=itemIndex-1
            }
            this.dataGet[this.namePath].data.splice(itemIndex+1,0,searchTableTable)  
            this.tableTable = itemIndex
            this.table=table
            this.table.index=itemIndex
             
            let checks = await this.asignTableSave(this.dataGet[this.namePath].data)
            await this.updateCrud({state: 'tableSave', data: checks})
          }          
        }
        
                    
      }
      console.log(this.tableTable,this.opentabletable)
    }
  }
}
</script>
<style>
.sw-search{
  margin-bottom: 0 !important
}
.sw-search .input-group-text {
    border-radius: 0 0 0 0 !important;
}
.sw-search .search-radius{
    border-radius:  0 0.25rem 0 0 !important;
}
.table--get > thead tr{
  border-left: 1px solid #ced4da;
  border-right: 1px solid #ced4da;
}
.table--get > thead tr th{
    color: #495057;
    background-color: #e9ecef;
    vertical-align: bottom;
    border-bottom: 1px solid #dee2e6;
    border-top: none;
}
.sw-sort{
  background-image: url('/images/sort.svg');
  width: 11px;
  height: 18px;
  float: right;
  background-size: cover;
  margin-top: 3px;
  cursor:pointer;
}
.sw-sortdown{
  background-image: url('/images/sortdown.svg');
}
.sw-sortup{
  background-image: url('/images/sortup.svg');
}
.tableIcon{
    position: absolute;
    bottom: -22px;
    left: 0;
    color: #525173 !important;
}
.paginatable .page-link{
  color: #495057 ;
}
.paginatableget .active .page-link{
  background: #6c757d ;
  border-color:#6c757d;
}
.paginatableget .page-link{
  border-top: none;
}
.paginatableget .page-link:focus{
    box-shadow: none;
}
.paginatableget .page-item span:first-child{
  border-top-left-radius:0 !important;
}
.paginatableget .page-item:last-child .page-link{
  border-top-right-radius:0 !important;
}
.opacity-table{
  opacity: 0.3
}
</style>